import {
    INotificationItem,
    NotificationItemMutation,
    NotificationItemsListTransaction,
} from '../../../interfaces';
import { singlePropertyMutation } from '../../../helpers/object-utils';

export function createIsNewMutation(notification: INotificationItem): NotificationItemMutation{
    return { id: notification.id, action: singlePropertyMutation('newMarkVisible', false) };
}

export function transactionToNewUpdate(transaction: NotificationItemsListTransaction): Array<NotificationItemMutation>{
    return [
        ...transaction.snapshot?.map(createIsNewMutation) ?? [],
        ...transaction.increment?.map(createIsNewMutation) ?? [],
    ];

}
